export default function Particles({ show }) {
  if (!show) return null;
  const colors = ["#22d3ee", "#a855f7", "#f43f5e", "#facc15"];
  return (
    <div className="pointer-events-none absolute inset-0 z-40 flex items-center justify-center overflow-hidden" data-testid="gift-particles">
      {Array.from({ length: 30 }).map((_, i) => {
        const a = (i / 30) * Math.PI * 2;
        const dist = 120 + Math.random() * 160;
        const dx = Math.cos(a) * dist, dy = Math.sin(a) * dist;
        const c = colors[i % colors.length];
        const s = 6 + Math.random() * 9;
        return <span key={i} className="particle"
          style={{ width: `${s}px`, height: `${s}px`, background: c, boxShadow: `0 0 10px ${c}`,
            "--dx": `${dx}px`, "--dy": `${dy}px`, animationDelay: `${Math.random() * 120}ms` }} />;
      })}
    </div>
  );
}
